'use client';

import style from './style.module.scss';
import LoadingIcon from '@/components/loadingIcon';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { setEmailPassword } from '@/app/csr-src/apis/profile/accountSetting.api';
import UKToast from '@/components/UKToast/index';
import Password from '@/components/user/password/password';
import { useTranslation } from '@/i18n/client';

import { pwdBtnStyle } from '@/app/csr-src/pages/profile/personalCenter/personalAccountSetDialog/components/style';

interface PasswordInputProps {
  jumpToDialog: (v: any) => void;
}

const CreatePasswordDom: React.FC<PasswordInputProps> = ({ jumpToDialog }) => {
  const [password, setPassword] = useState(''); // 初始密码
  const [psdDisabled, setPsdDisabled] = useState(true); // 按钮禁用
  const [isLoading, setIsLoading] = useState(false); // 是否加载中

  // 点击 submit
  const handleSubmit = async () => {
    setIsLoading(true);
    const [err, res]: any = await setEmailPassword({ password: password });
    if (err) {
      setIsLoading(false);
      throw new Error();
    }
    if (res && res.success) {
      UKToast.show({
        icon: 'success',
        content: res.msg || t('login.common.addPwdSuccess'),
      });
      jumpToDialog({
        type: 'addPasswordSuccess',
        flag: 'addPasswordSuccess',
        successText: t('login.common.addPwdSuccess'),
      });
      setIsLoading(false);
    } else {
      UKToast.show({
        icon: 'error',
        content: res.msg,
      });
      setIsLoading(false);
    }
  };

  const { t } = useTranslation();
  return (
    <div className={style.createPasswordWrap}>
      {/* Input 输入框盒子 */}
      <div className={style.password}>
        <Password setPsdVal={setPassword} psdValidatedHandle={setPsdDisabled} />

        <Button
          variant='contained'
          onClick={handleSubmit}
          disabled={psdDisabled || isLoading}
          startIcon={isLoading && <LoadingIcon />}
          sx={{ ...pwdBtnStyle }}
        >
          {t('login.common.submit')}
        </Button>
      </div>
    </div>
  );
};

export default CreatePasswordDom;
